function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class ColItemNavigation extends HTMLElement {
  constructor() {
    super();

    const links = this.querySelectorAll(".col-multi-nav-link");

    links.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const target = event.target.getAttribute('data-target');
        const targetElement = document.querySelector(`#${target}`);

        window.setTimeout(() => {
          if (targetElement) {
            if(target == 'all'){
              this.scrollIntoView({ behavior: 'smooth' });
            }else{
              let w_offset = 123;
              if(window.screen.width > 767){
                w_offset = 190;
              }
              
              window.scrollTo({
                behavior: 'smooth',
                top: targetElement.getBoundingClientRect().top - document.body.getBoundingClientRect().top - w_offset
              })
            }
          }
        });
      });
    })
  }
}

customElements.define('col-item-navigation', ColItemNavigation);

class ColMultiSort extends HTMLElement {
  constructor() {
    super();

    const sortLabel = this.querySelector(".sort-filters__label");
    const options = this.querySelectorAll('li');

    sortLabel.addEventListener('click', (event) => {
      if(this.classList.contains('active')){
        this.classList.remove('active')
      }else{
        this.classList.add('active')
      }
    })

    options.forEach((option) => {
      option.addEventListener('click', (e) => {
        const sortValue = option.getAttribute('data-value');
        const sortText = option.innerText;
        const listCollections = document.querySelectorAll('.col-multi-list');
        const labelText = sortLabel.querySelector('label');
        const selectedOptionLabel = document.querySelector('.sort-option-selected');

        this.classList.remove("active");
        labelText.innerText = sortText;
        selectedOptionLabel.classList.remove('sort-option-selected');
        option.classList.add('sort-option-selected');

        listCollections.forEach((listCollection) => {
          this.optionHandle(listCollection, sortValue);
        })
      })
    })

    document.addEventListener("click", (e) => {
      const isClosest = e.target;
      const colSort = isClosest.closest('col-multi-sort');
      
      if (!colSort) {
        this.classList.remove("active");
      }
    });
  }

  optionHandle(listCollection, sortValue) {
    const colUrl = listCollection.getAttribute('data-handle');
    const url = `${colUrl}?sort_by=${sortValue}&view=multi`;
    const desktopWrap = listCollection.querySelector('.desktop_only');
    const desktopList = desktopWrap.querySelector('.products_grid_container');
    const desktopGridClass = desktopList.getAttribute('data-class');
    const listLimit = parseInt(listCollection.getAttribute('data-limit'));

    const mobileWrap = listCollection.querySelector('.mobile_only');
    const mobileGrid = mobileWrap.querySelector('.products_grid_container');
    const mobileGridClass = mobileGrid.getAttribute('data-class');
    const mobileGridCount = parseInt(mobileGrid.getAttribute('data-grid'));
    const mobileIModalHolders = mobileWrap.querySelectorAll('.modal-holder');
    const mobileIModalOverlays = mobileWrap.querySelectorAll('.modal-overlay');

    fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
      const listColContent = responseHTML.querySelector('.multi-items-wrap');
      const deskttopCells = listColContent.querySelectorAll('.desktop_only li.wade');
      const gridCount = parseInt(desktopList.getAttribute('data-grid'));

      if(desktopList.classList.contains('slick-slider')){
        $(desktopList).slick('unslick');
        
        desktopList.innerHTML = "";
        deskttopCells.forEach((deskttopCell, index) => {
          if(index < listLimit){
            deskttopCell.classList.add(desktopGridClass);
            desktopList.append(deskttopCell);
          }
        })
        $(desktopList).slick({
          infinite: true,
          arrows: false,
          dots: false,
          slidesToShow: gridCount,
          nextArrow: "<button role='button' tabindex='0'  class='slick-next slick-arrow slider-arrow slider-arrow--next' aria-label='Next' type='button' style=''>Next</button>",
          prevArrow: "<button role='button' tabindex='0'  class='slick-prev slick-arrow slider-arrow slider-arrow--prev' aria-label='Previous' type='button' style=''>Previous</button>"
        });
      }else{
        desktopList.innerHTML = "";
        deskttopCells.forEach((deskttopCell, index) => {
          if(index < listLimit){
            deskttopCell.classList.add(desktopGridClass);
            desktopList.append(deskttopCell);
          }
        })
      }

      const mobileContent = listColContent.querySelector('.mobile_only');
      const mobileContentCells = mobileContent.querySelectorAll('li.wade');
      const mobileModalHolders = mobileContent.querySelectorAll('.mobile_only .modal-holder');
      const mobileModalOverlays = mobileContent.querySelectorAll('.mobile_only .modal-overlay');

      if(mobileGrid.classList.contains('slick-slide')){
        $(mobileGrid).slick('unslick');

        mobileGrid.innerHTML = "";
        if(mobileIModalHolders){
          mobileIModalHolders.forEach((mobileIModalHolder, index) => {
            mobileIModalHolder.remove();
          })
        }
        if(mobileIModalOverlays){
          mobileIModalOverlays.forEach((mobileIModalOverlay, index) => {
            mobileIModalOverlay.remove();
          })
        }
        
        mobileContentCells.forEach((mobileCell, index) => {
          if(index < listLimit){
            mobileCell.classList.add(mobileGridClass);
            mobileGrid.append(mobileCell);
          }
        })

        mobileModalHolders.forEach((mobileModalHolder, index) => {
          if(index < listLimit){
            mobileGrid.insertAdjacentElement('afterend', mobileModalHolder);
          }
        })

        mobileModalOverlays.forEach((mobileModalOverlay, index) => {
          if(index < listLimit){
            mobileGrid.insertAdjacentElement('afterend', mobileModalOverlay);
          }
        })

        $(mobileGrid).slick({
          infinite: true,
          arrows: false,
          dots: false,
          slidesToShow: mobileGridCount,
          nextArrow: "<button role='button' tabindex='0'  class='slick-next slick-arrow slider-arrow slider-arrow--next' aria-label='Next' type='button' style=''>Next</button>",
          prevArrow: "<button role='button' tabindex='0'  class='slick-prev slick-arrow slider-arrow slider-arrow--prev' aria-label='Previous' type='button' style=''>Previous</button>"
        });
      }else{
        mobileGrid.innerHTML = "";
        if(mobileIModalHolders){
          mobileIModalHolders.forEach((mobileIModalHolder, index) => {
            mobileIModalHolder.remove();
          })
        }
        if(mobileIModalOverlays){
          mobileIModalOverlays.forEach((mobileIModalOverlay, index) => {
            mobileIModalOverlay.remove();
          })
        }
        mobileContentCells.forEach((mobileCell, index) => {
          if(index < listLimit){
            mobileCell.classList.add(mobileGridClass);
            mobileGrid.append(mobileCell);
          }
        })

        mobileModalHolders.forEach((mobileModalHolder, index) => {
          if(index < listLimit){
            mobileGrid.insertAdjacentElement('afterend', mobileModalHolder);
          }
        })

        mobileModalOverlays.forEach((mobileModalOverlay, index) => {
          if(index < listLimit){
            mobileGrid.insertAdjacentElement('afterend', mobileModalOverlay);
          }
        })
      }
    })
    .finally(() => {
      
    });
  }
}

customElements.define('col-multi-sort', ColMultiSort);

class ColListWarp extends HTMLElement {
  constructor() {
    super();

    this.loadMoreCTA = this.querySelector('.js-col-multi-ajax-cta');
    this.loadLessCTA = this.querySelector('.js-col-multi-less-cta');
    this.limitation = parseInt(this.getAttribute('data-limit'));

    if(this.loadMoreCTA){
      this.loadMoreCTA.addEventListener('click', (e) => {
        e.preventDefault();

        const colSortValue = document.querySelector('.sort-option-selected').getAttribute('data-value');
        const collectionUrl = this.getAttribute('data-handle');
        let colPagination = parseInt(this.querySelector('.col-multi-list--cta').getAttribute('data-pagination'));

        this.optionHandle(this, colSortValue, colPagination);

        colPagination++;
        this.querySelector('.col-multi-list--cta').setAttribute('data-pagination', colPagination);
      })
    }

    if(this.loadLessCTA){
      this.loadLessCTA.addEventListener('click', (e) => {
        e.preventDefault();

        const desktopListCells = this.querySelectorAll('.desktop_only li.wade');
        const mobileListCells = this.querySelectorAll('.mobile_only li.wade');

        this.loadLessCTA.classList.toggle('more-view');
        if (this.loadLessCTA.classList.contains('more-view')) {
          this.loadLessCTA.innerText = 'View More';
          desktopListCells.forEach((desktopListCell, index) => {
            if(index >= this.limitation){
              desktopListCell.classList.add('hide');
            }
          })
  
          mobileListCells.forEach((mobileListCell, index) => {
            if(index >= this.limitation){
              mobileListCell.classList.add('hide');
            }
          })

          let w_offset = 123;
          if(window.screen.width > 767){
            w_offset = 237;
          }
          
          window.scrollTo({
            behavior: 'smooth',
            top: this.getBoundingClientRect().top - document.body.getBoundingClientRect().top - w_offset
          })
        }else{
          this.loadLessCTA.innerText = 'View Less';
          desktopListCells.forEach((desktopListCell, index) => {
            desktopListCell.classList.remove('hide');
          })
  
          mobileListCells.forEach((mobileListCell, index) => {
            mobileListCell.classList.remove('hide');
          })
        }
      })
    }
  }
  
  optionHandle(listCollection, sortValue, colPagination) {
    const colUrl = listCollection.getAttribute('data-handle');
    const url = `${colUrl}?sort_by=${sortValue}&view=multi&page=${colPagination}`;
    const desktopWrap = listCollection.querySelector('.desktop_only');
    const desktopList = desktopWrap.querySelector('.products_grid_container');
    const desktopGridClass = desktopList.getAttribute('data-class');

    const mobileWrap = listCollection.querySelector('.mobile_only');
    const mobileGrid = mobileWrap.querySelector('.products_grid_container');
    const mobileGridClass = mobileGrid.getAttribute('data-class');
    const mobileGridCount = parseInt(mobileGrid.getAttribute('data-grid'));
    const mobileIModalHolders = mobileWrap.querySelectorAll('.modal-holder');
    const mobileIModalOverlays = mobileWrap.querySelectorAll('.modal-overlay');
    const paginationLimit = 12;

    fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
      const listColContent = responseHTML.querySelector('.multi-items-wrap');
      const deskttopCells = listColContent.querySelectorAll('.desktop_only li.wade');
      const gridCount = parseInt(desktopList.getAttribute('data-grid'));

      if(desktopList.classList.contains('slick-slider')){
        $(desktopList).slick('unslick');
        
        if(colPagination == 1) desktopList.innerHTML = "";
        deskttopCells.forEach((deskttopCell, index) => {          
          deskttopCell.classList.add(desktopGridClass);
          desktopList.append(deskttopCell);
        })
        $(desktopList).slick({
          infinite: true,
          arrows: true,
          dots: false,
          slidesToShow: gridCount,
          nextArrow: "<button role='button' tabindex='0'  class='slick-next slick-arrow slider-arrow slider-arrow--next' aria-label='Next' type='button' style=''>Next</button>",
          prevArrow: "<button role='button' tabindex='0'  class='slick-prev slick-arrow slider-arrow slider-arrow--prev' aria-label='Previous' type='button' style=''>Previous</button>"
        });
      }else{
        if(colPagination == 1) desktopList.innerHTML = "";
        deskttopCells.forEach((deskttopCell, index) => {
          deskttopCell.classList.add(desktopGridClass);
          desktopList.append(deskttopCell);
        })

        //read more button handle
        if(deskttopCells.length < 12){
          this.loadMoreCTA.classList.add('hide');
          this.loadLessCTA.classList.remove('hide');
        }
      }

      const mobileContent = listColContent.querySelector('.mobile_only');
      const mobileContentCells = mobileContent.querySelectorAll('li.wade');
      const mobileModalHolders = mobileContent.querySelectorAll('.mobile_only .modal-holder');
      const mobileModalOverlays = mobileContent.querySelectorAll('.mobile_only .modal-overlay');

      if(mobileGrid.classList.contains('slick-slider')){
        $(mobileGrid).slick('unslick');

        if(colPagination == 1) mobileGrid.innerHTML = "";
        if(mobileIModalHolders && colPagination == 1){
          mobileIModalHolders.forEach((mobileIModalHolder, index) => {
            mobileIModalHolder.remove();
          })
        }
        if(mobileIModalOverlays && colPagination == 1){
          mobileIModalOverlays.forEach((mobileIModalOverlay, index) => {
            mobileIModalOverlay.remove();
          })
        }
        
        mobileContentCells.forEach((mobileCell, index) => {
          mobileCell.classList.add(mobileGridClass);
          mobileGrid.append(mobileCell);
        })

        mobileModalHolders.forEach((mobileModalHolder, index) => {
          mobileGrid.insertAdjacentElement('afterend', mobileModalHolder);
        })

        mobileModalOverlays.forEach((mobileModalOverlay, index) => {
          mobileGrid.insertAdjacentElement('afterend', mobileModalOverlay);
        })

        $(mobileGrid).slick({
          infinite: true,
          arrows: true,
          dots: false,
          slidesToShow: mobileGridCount,
          nextArrow: "<button role='button' tabindex='0'  class='slick-next slick-arrow slider-arrow slider-arrow--next' aria-label='Next' type='button' style=''>Next</button>",
          prevArrow: "<button role='button' tabindex='0'  class='slick-prev slick-arrow slider-arrow slider-arrow--prev' aria-label='Previous' type='button' style=''>Previous</button>"
        });
      }else{
        if(colPagination == 1) mobileGrid.innerHTML = "";
        if(mobileIModalHolders && colPagination == 1){
          mobileIModalHolders.forEach((mobileIModalHolder, index) => {
            mobileIModalHolder.remove();
          })
        }
        if(mobileIModalOverlays && colPagination == 1){
          mobileIModalOverlays.forEach((mobileIModalOverlay, index) => {
            mobileIModalOverlay.remove();
          })
        }
        mobileContentCells.forEach((mobileCell, index) => {
          mobileCell.classList.add(mobileGridClass);
          mobileGrid.append(mobileCell);
        })

        mobileModalHolders.forEach((mobileModalHolder, index) => {
          mobileGrid.insertAdjacentElement('afterend', mobileModalHolder);
        })

        mobileModalOverlays.forEach((mobileModalOverlay, index) => {
          mobileGrid.insertAdjacentElement('afterend', mobileModalOverlay);
        })

        //read more button handle
        if(deskttopCells.length < 12){
          this.loadMoreCTA.classList.add('hide');
          this.loadLessCTA.classList.remove('hide');
        }
      }
    })
    .finally(() => {
      
    });
  }
}

customElements.define('col-list-wrap', ColListWarp);